/** The free checker: a static page on FormOne's site that calls the public API. */
export const CHECKER_URL = "https://formone.pk/checkone";
export const CHECKER_LABEL = "formone.pk/checkone";
